import React, { useContext, useEffect, useState } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';

import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import LazyLoading from '../../../components/LazyLoading';

import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { BankAccountType } from '../../../app/models/BankAccountType';
import useBankAccountTypeService from '../../../app/services/hooks/useBankAccountType';
import BankAccountTypeForm from './forms/BankAccountTypeForm';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const BankAccountTypeCreate = ({ onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [errorGetData, setErrorGetData] = useState('');
    const [bankAccountType, setBankAccountType] = useState<BankAccountType>({ name: '' });

    const [errorFields, setErrorFields] = useState<any>();

    const { fetchingStoreBankAccountType, storeBankAccountType } = useBankAccountTypeService();

    // useEffect(() => {

    // }, []);

    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando tipo de cuenta...');
        storeBankAccountType(bankAccountType, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    if (errorGetData !== '') {
        return <div>{errorGetData}</div>;
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <BankAccountTypeForm
                        bankAccountTypeDataForm={bankAccountType}
                        setBankAccountTypeDataForm={setBankAccountType}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm
                        callbackCancel={cancel}
                        locked={fetchingStoreBankAccountType}
                    />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingStoreBankAccountType} />
                </div>
            </div>
        </>
    );
};

export default BankAccountTypeCreate;
